import React, { useState } from "react";
import { withRouter } from "react-router-dom";

import HealthQuestionnaireDataLayout from "./salud-pymes-questionnaire/health-questionnaire-data-layout";
import DicotomicCheckbox from "../../../../../components/dicotomic-checkbox/dicotomic-checkbox";
import MainButton from "../../../../../components/main-button";
import InfoModal from "../../../../../components/info-modal";
import LeftInfoModal from "../../../../../components/left-info-modal";
import {
  InfoCard,
  QuestionnairesContainer,
  SaludPymesQuestionnairesContainer,
} from "./salud-pymes-questionnaires-style";
import { images } from "../../../../../assets";

import { QUESTIONNAIRE_TYPE } from "../../../../../constants/salud-pymes-constants";
import { withPolicy } from "../../../../../context/mixin/with-policy";
import SaludPymesServices from "../../../../../services/SaludPymesServices";

import { SaludPymesHireMenuHelper } from "../../../../../components/salud-pymes-hire-menu/salud-pymes-hire-menu-helpers";
import { Steps } from "../../../../../components/salud-pymes-hire-menu/salud-pymes-hire-menu-types";
import { SendaResponseQuestionnaire } from "./salud-pymes-questionnaire/health-questionnaire-dto/health-questionnaire-dto";
import { SaludPymesQuestionnairesProps } from "./salud-pymes-questionnaires-types";
import { withGeneral } from "../../../../../context/mixin/with-general";


const SaludPymesQuestionnaires = (props: SaludPymesQuestionnairesProps) => {
  const cleanModal = { show: false, message: "" };
  const prevType = props.data.questionnaireType || null;
  const [type, setType] = useState<string | null>(prevType);
  const [errorModal, setErrorModal] = useState<{ show: boolean; message: string }>(cleanModal);
  const [showInfoModal, setShowInfoModal] = useState<boolean>(false);

  const onClickNext = async () => {
    setShowInfoModal(false);
    const data = {
      COTIZACION: props.data.idcotiza,
      RESPUESTAS_CUESTIONARIOS: [],
      MODALIDAD_CUESTIONARIO: QUESTIONNAIRE_TYPE.DIGITAL,
    } as SendaResponseQuestionnaire;
    try {
      await SaludPymesServices.uploadQuestionnaires(props.setLoading, true, data);
      props.policy.setHealthData({
        preQuestionnaire: true,
        questionnaireType: type,
      });
      props.saveHiring(false, true);
      props.history.push(SaludPymesHireMenuHelper.getNextStepNavigationPath(Steps.Cuestionarios));
    } catch (error) {
      setErrorModal({ show: true, message: typeof error === "string" ? error : "" });
    }
  };

  const onClickBack = () => {
    props.history.push(SaludPymesHireMenuHelper.getPreviousStepNavigationPath(Steps.Cuestionarios));
  };

  return (
    <SaludPymesQuestionnairesContainer>
      <div className="new-hiring-flow-status">
        <div className="new-hiring-flow-status-title">
          <h2>DATOS CLÍNICOS DE LOS ASEGURADOS</h2>
        </div>
      </div>

      <div className="legal">
        <InfoCard origin={origin}>
          <div className="icon ">
            <img src={images.IconInfoBlue} alt="" />
          </div>
          <div className="content leftMargin10">
            <p>La selección se aplica a todos los asegurados de esta contratación</p>
          </div>
        </InfoCard>
      </div>

      <div className="type-options">
        <DicotomicCheckbox
          initChecked={type === QUESTIONNAIRE_TYPE.MANUAL}
          className="optional"
          checkboxText="Envío Manual"
          onChange={() => setType(QUESTIONNAIRE_TYPE.MANUAL)}
        />
        <DicotomicCheckbox
          initChecked={type === QUESTIONNAIRE_TYPE.DIGITAL}
          className="optional"
          checkboxText="Envío Digital"
          onChange={() => setType(QUESTIONNAIRE_TYPE.DIGITAL)}
        />
      </div>

      {type && type === QUESTIONNAIRE_TYPE.MANUAL && (
        <QuestionnairesContainer>
          <HealthQuestionnaireDataLayout {...props} />
        </QuestionnairesContainer>
      )}

      {type && type === QUESTIONNAIRE_TYPE.DIGITAL && (
        <div className="questionnaire-buttons-container">
          <div className="button-item">
            <MainButton
              withTab={true}
              icon={true}
              type="white"
              iconImg={images.IconArrowLeftBlue}
              text="Atrás"
              onClick={onClickBack}
            />
          </div>
          <div className="button-item">
            <MainButton text="Siguiente" onClick={() => setShowInfoModal(true)} />
          </div>
        </div>
      )}

      <LeftInfoModal
        img={images.WarningError}
        className="error"
        mainTitle="Se ha producido un error"
        mainText={errorModal.message}
        buttonText="Cerrar"
        active={errorModal.show}
        onClickAccept={() => setErrorModal(cleanModal)}
        close={() => setErrorModal(cleanModal)}
        noSecondaryButton
      />
      {
        showInfoModal && (
          <InfoModal
            className=""
            active={showInfoModal}
            img={images.IconCheckboxBlue}
            mainText="La elección de cuestionario digital para todos los asegurados elimina los datos de los cuestionarios manuales existentes."
            onClickAccept={onClickNext}
            buttonText="Continuar"
            close={() => setShowInfoModal(false)}
          />
        )
      }

    </SaludPymesQuestionnairesContainer>
  );
};

export default withPolicy(withGeneral(withRouter(SaludPymesQuestionnaires)));
